import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NotificationContainerService } from './notification-container.service';

@Component({
  selector: 'app-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss']
})
export class NotificationContainerComponent implements OnInit, OnDestroy {
  @Input() showSpecificMessage: boolean;

  notificationSubscription;
  messages = [];

  constructor(public notificationService: NotificationContainerService) {
    this.notificationSubscription = this.notificationService.notificationChange.subscribe(() => {
      if (!this.showSpecificMessage) {
        this.updateMessages();
      }
    });
  }

  ngOnInit() {
    this.updateMessages();
  }

  ngOnDestroy() {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  }

  updateMessages() {
    if (!this.showSpecificMessage) {
      this.messages = this.notificationService.getMessages();
    }
  }

  toggleHidden(i) {
    if (this.messages[i]) {
      this.messages[i].showmore = !this.messages[i].showmore;
    }
  }

  toggleHiddenShowOnly(i) {
    if (this.messages[i]) {
      this.messages[i].showmore = true;
    }
  }

}
